import React, { useState } from 'react';
import { Modal, Box, Button, TextField } from '@mui/material';
import { manualApi } from '../../api/global';
import PropTypes from 'prop-types';
import ISBNImg from '../../assets/images/img_isbn.svg';
import AlertModal from '../common/AlertModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '480px',
  height: '490px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
};

function AddManualModal({ open, setOpen, reload }) {
  const [isbnValue, setIsbnValue] = useState('');
  const [alert, setAlert] = useState(false);

  // isbn ; "9783161484100", "9783161484100"

  const handleAddClick = async () => {
    if (!isbnValue) return;
    try {
      const { status } = await manualApi.addStudentManual({ isbn: isbnValue });
      if (status) {
        setOpen(false);
        setIsbnValue('');
        reload();
      } else {
        setAlert(true);
      }
    } catch (error) {
      setAlert(true);
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(null)}>
      <Box sx={style}>
        <div className="w-full flex flex-col justify-start items-center">
          <div className="text-[18px] font-[700] mb-[28px]">교재 추가하기</div>
          <div className="w-full font-[400] text-[14px] mb-[5px]">
            교재 ISBN
          </div>
          <TextField
            value={isbnValue}
            fullWidth
            size="small"
            placeholder="ISBN을 입력해주세요"
            onChange={e => setIsbnValue(e.target.value)}
            sx={{ mb: '24px' }}
          />
          <div className="flex flex-col justify-center items-center w-[258px] h-[200px] bg-[#F0F0F0]">
            <div className="font-[400] text-[12px] flex flex-col justify-center items-center">
              <span className="font-[700]">‘ISBN’이란?</span>
              <span>국제 표준 도서 번호를 의미하며,</span>
              <span>교재 뒷표지 바코드 하단에 위치합니다.</span>
            </div>
            <img src={ISBNImg} alt="ISBN_sample" />
          </div>
        </div>
        <div className="flex w-full items-center justify-center gap-2">
          <Button
            variant="dark"
            onClick={() => {
              setOpen(false);
            }}
            sx={{ width: '113px' }}
          >
            닫기
          </Button>
          <Button
            variant="contained"
            onClick={handleAddClick}
            sx={{ width: '113px' }}
            disabled={isbnValue?.length < 1}
          >
            추가
          </Button>
        </div>
        <AlertModal
          open={alert}
          setOpen={setAlert}
          content={`유효하지 않은 ISBN입니다.\n다시 확인해주세요.`}
          confirmLabel="확인"
          onConfirm={() => setAlert(false)}
        />
      </Box>
    </Modal>
  );
}

AddManualModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
};

export default React.memo(AddManualModal);
